import { render, staticRenderFns } from "./ui-text.vue?vue&type=template&id=43823f28&scoped=true&"
import script from "./ui-text.vue?vue&type=script&lang=js&"
export * from "./ui-text.vue?vue&type=script&lang=js&"
import style0 from "./ui-text.vue?vue&type=style&index=0&id=43823f28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43823f28",
  null
  
)

export default component.exports